import { render } from "./CascadeForm.vue?vue&type=template&id=ae48dbe2&ts=true"
import script from "./CascadeForm.vue?vue&type=script&lang=ts"
export * from "./CascadeForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__